import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LoadingSpinner } from './LoadingSpinner';
import { getRoomCredential } from '../services/RoomSession';

export default function RequirePlayerSession({ children }) {
    const { hasPlayerSession, user, isGuest, initializing } = useAuth();
    const location = useLocation();
    const roomId = /^\/play\/([^/]+)\//.exec(location.pathname)?.[1];
    if (roomId && getRoomCredential(roomId)) return children;
    if (initializing) return <LoadingSpinner show />;
    return (hasPlayerSession ?? (!!user || !!isGuest)) ? children : <Navigate to="/" state={{ returnTo: location.pathname }} replace />;
}
